import { StyledNewProductForm } from './style';
import { Table } from '../../Table';
import { useIntl } from 'react-intl';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import { InfrastructureProps } from 'interfaces/BackendModels';
import { Checkbox } from 'ui/Checkbox';
import React, { useMemo } from 'react';
import { useAuth } from 'hooks/useAuth';

interface StructureProps {
  isEditMode?: boolean;
}

export const NewProductsStructureForm: React.FC<StructureProps> = ({ isEditMode }) => {
  const intl = useIntl();
  const { user } = useAuth();
  const form = useFormInstance();

  const stableFilter = useMemo(() => {
    return { farmId: user?.farmId };
  }, [user?.farmId]);

  const columns = [
    {
      title: intl.formatMessage({ id: 'delivery.address' }),
      dataIndex: 'address_pak',
      render: (value: string) => value,
    },
    {
      title: intl.formatMessage({ id: 'general.name' }),
      dataIndex: 'object_name',
      render: (value: string) => value,
    },
    {
      title: intl.formatMessage({ id: 'general.status' }),
      render: (record: InfrastructureProps) => {
        return <Checkbox name={`infrastructures.${record.id}`} />;
      },
    },
  ];

  return (
    <StyledNewProductForm>
      <Table
        className='products-structure-table'
        url={'/api/v2/farm/infrastructures'}
        columns={columns}
        filter={stableFilter}
        saveData={(structures: InfrastructureProps[]) => {
          if (!isEditMode) {
            structures.map((structure) => form.setFieldValue(`infrastructures.${structure.id}`, true));
          }
        }}
      />
    </StyledNewProductForm>
  );
};
